import { z } from "zod";
export const PackageTierBrandingPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("package-tier-branding-policy.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalPackageTierBrandingPolicy(recordedAt) {
    return PackageTierBrandingPolicyV1Schema.parse({
        schemaVersion: "package-tier-branding-policy.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=package-tier-branding-policy.js.map